import { ControllerPaletteColor } from './__palette-color';

export enum ControllerDataGridContainerColor {
  HeaderBorder = ControllerPaletteColor.Gray800,
  HeaderBg = ControllerPaletteColor.Gray950,
  HeaderFg = ControllerPaletteColor.Gray200,
  HeaderFgError = ControllerPaletteColor.Red500,
  HeaderMenuItemIcon = ControllerPaletteColor.Gray300,
}
